import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { Input, Button, Form, message, Select } from 'antd'; // Include Select
import '@fortawesome/fontawesome-free/css/all.min.css';
import './NewContactForm.css';
import image from '../assets/images/pabel4.jpg';

const { Option } = Select; // Destructure Option for Select

const NewContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: '',
    courseCategory: '',
    selectedCourse: ''
  });

  const courseOptions = {
    "Short Term Courses": ["C", "C++", "Java", "Python", "SQL"],
    "Long Term Courses": [
      "Full Stack Development",
      "Datacom Networking",
      "Competitive Programming",
      "Python with Data Science",
      "Agile / DevOps",
      "Cloud Computing"
    ]
  };

  // Handle dropdown changes
  const handleDropdownChange = (value, key) => {
    setFormData({ ...formData, [key]: value });
  };

  // Send email function using EmailJS
  const sendEmail = (values) => {
    const emailParams = {
      ...values
    };

    emailjs
      .send(
        'service_oit4bk9', // Your service ID
        'template_xny0vd6', // Your template ID
        emailParams,
        '6xlgr_2EFvcPEjnDG' // Your user ID
      )
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        message.success('Message sent successfully!');
      })
      .catch((err) => {
        console.error('FAILED...', err);
        message.error('Failed to send the message. Please try again later.');
      });
  };

  return (
    <div className="new-contact-form">
      <div className="form-image-container">
        <img src={image} alt="Contact Us" className="form-image" />
      </div>

      <div className="new-contact-content">
        <div className="new-contact-right">
          <h2 className="cnh-2">For Query</h2>
          <Form
            onFinish={sendEmail}
            layout="vertical"
            style={{ maxWidth: '800px', margin: '0 auto' }}
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: 'Please enter your name!' }]}
            >
              <Input placeholder="Name" />
            </Form.Item>

            <Form.Item
              label="Phone"
              name="phone"
              rules={[
                { required: true, message: 'Please enter your phone number!' },
                { pattern: /^[0-9]{10}$/, message: 'Enter a valid 10-digit phone number!' }
              ]}
            >
              <Input placeholder="Phone" />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Please enter your email!' },
                { type: 'email', message: 'Enter a valid email address!' }
              ]}
            >
              <Input placeholder="Email" />
            </Form.Item>

            <Form.Item
              label="Subject"
              name="subject"
              rules={[{ required: true, message: 'Please enter the subject!' }]}
            >
              <Input placeholder="Subject" />
            </Form.Item>

            <Form.Item
              label="Category"
              name="courseCategory"
              rules={[{ required: true, message: 'Please select a category!' }]}
            >
              <Select
                placeholder="Select Category"
                onChange={(value) => handleDropdownChange(value, 'courseCategory')}
              >
                {Object.keys(courseOptions).map((category) => (
                  <Option key={category} value={category}>
                    {category}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {formData.courseCategory && (
              <Form.Item
                label="Course"
                name="selectedCourse"
                rules={[{ required: true, message: 'Please select a course!' }]}
              >
                <Select
                  placeholder="Select Course"
                  onChange={(value) => handleDropdownChange(value, 'selectedCourse')}
                >
                  {courseOptions[formData.courseCategory].map((course) => (
                    <Option key={course} value={course}>
                      {course}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            <Form.Item
              label="Message"
              name="message"
              rules={[
                { required: true, message: 'Please enter your message!' },
                { min: 10, message: 'Message should be at least 10 characters!' }
              ]}
            >
              <Input.TextArea placeholder="Message" rows={4} />
            </Form.Item>

            <Button type="primary" htmlType="submit" size="middle" block>
              Send Message
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default NewContactForm;
